import { useState } from "react";
import { useNavigate } from "react-router";
import Button from "../../components/Button";
import Form from "../../components/Form";
import { FieldInfo } from "../../components/FormField";
import Header from "../../components/Header";
import Input from "../../components/Input";
import Panel from "../../components/Panel";
import { useCloneSetup } from "../../hooks/useSetups";
import { Setup } from "../../http/onlyclicksApi";
import { translate } from "../../i18n";
import Page from "../../layouts/Page";
import { Language } from "../../types";
import styles from "./CloneSetupPage.module.css";
import FilterableSetupList from "./FilterableSetupList";

interface FormData {
  name: string;
}

const CloneSetupPage = () => {
  const [selectedSetup, setSelectedSetup] = useState<Setup>();

  const mutation = useCloneSetup();
  const i18n = translate(Language.English);
  const navigate = useNavigate();

  return (
    <Page>
      <Header backLink="/setups" heading="Clone setup" />
      {!selectedSetup && (
        <>
          <FilterableSetupList
            onClick={(setup) => {
              setSelectedSetup(setup);
            }}
          />
        </>
      )}
      {selectedSetup && (
        <Panel>
          <p className={styles.summary}>
            Setup to clone: <b>{selectedSetup.name}</b>
          </p>
          <Form<FormData>
            onSubmit={({ value }) =>
              mutation.mutate(
                {
                  id: selectedSetup!.id,
                  name: value.name,
                },
                {
                  onSuccess: (setup) => {
                    navigate(`/setups/${setup.id}`);
                  },
                },
              )
            }
          >
            {(form) => (
              <>
                <form.Field
                  name="name"
                  validators={{
                    onChange: ({ value }) =>
                      !value ? "A name is required" : undefined,
                  }}
                >
                  {(field) => (
                    <>
                      <label htmlFor={field.name}>{i18n.name}</label>
                      <Input
                        name={field.name}
                        value={field.state.value}
                        onBlur={field.handleBlur}
                        onChange={(e) => field.handleChange(e.target.value)}
                      />
                      <FieldInfo field={field} />
                    </>
                  )}
                </form.Field>
                <div className={styles.submitBar}>
                  <Button
                    type="accent"
                    fullWidth={true}
                    isLoading={mutation.isPending}
                    buttonProps={{
                      type: "submit",
                      disabled: mutation.isPending,
                    }}
                  >
                    Clone
                  </Button>
                </div>
              </>
            )}
          </Form>
        </Panel>
      )}
    </Page>
  );
};

export default CloneSetupPage;
